import { useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { DrawerTopBarWithAction } from "@/components/Drawer/DrawerTopBar";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import { TextField } from "@/components/TextField/TextField";

type SearchByNameContentsProps = {
  value: string;
  onSubmit: (newQuery: string) => void;
  onClose: () => void;
};

export const SearchByNameContents = ({
  value,
  onSubmit,
  onClose,
}: SearchByNameContentsProps) => {
  const intl = useIntl();
  const [query, setQuery] = useState(value);

  return (
    <>
      <DrawerTopBarWithAction
        onCloseClick={onClose}
        title={intl.formatMessage({
          defaultMessage: "Search by name",
          description: "Label for the hotel name search input field in filters",
        })}
        actionElement={
          <Button
            onClick={(e) => {
              setQuery("");
              e.currentTarget.blur();
            }}
            variant="text"
            size="small"
          >
            {intl.formatMessage({
              defaultMessage: "Clear filter",
              description: "Button to remove a single active filter",
            })}
          </Button>
        }
      />

      <div className="mt-4">
        <TextField
          label={intl.formatMessage({
            defaultMessage: "Enter hotel name",
            description: "Placeholder text for the hotel name search input",
          })}
          fullWidth
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      <div className="mt-4">
        <Button
          fullWidth
          onClick={() => {
            onSubmit(query);
          }}
          variant="contained"
          size="large"
        >
          {intl.formatMessage({
            defaultMessage: "Apply",
            description: "Button to apply selected filters or changes",
          })}
        </Button>
      </div>
    </>
  );
};

type Props = SearchByNameContentsProps & {
  open: boolean;
};

export const SearchByNameDrawer = ({
  open,
  value,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      {/* need to reset the state when drawer is open/closed */}
      {open ? (
        <SearchByNameContents
          value={value}
          onSubmit={onSubmit}
          onClose={onClose}
        />
      ) : null}
    </SwipeableDrawer>
  );
};
